/*-----------------------------------------------------------------------------
| Copyright (c) Jupyter Development Team.
| Distributed under the terms of the Modified BSD License.
|----------------------------------------------------------------------------*/

/* This file was auto-generated by ensurePackage() in @jupyterlab/buildutils */
import '@jupyterlab/apputils/style/index.js';
import '@jupyterlab/codeeditor/style/index.js';
import '@jupyterlab/rendermime/style/index.js';
import '@jupyterlab/docregistry/style/index.js';
import '@jupyterlab/application/style/index.js';
import '@jupyterlab/cells/style/index.js';
import '@jupyterlab/console/style/index.js';
import '@jupyterlab/fileeditor/style/index.js';
import '@jupyterlab/notebook/style/index.js';
import '@jupyterlab/debugger/style/index.js';
import '@jupyterlab/logconsole/style/index.js';
